/*  MUI  */
import { Box, Tab } from '@mui/material';

/*  Shared  */
import { MUITabsWrapper } from 'application/Shared/Components/MUITabsWrapper';
import { FontSizes } from 'application/Shared/Constants';

/*  React  */
import React from 'react';

export const ChosenReportHeaderTabs = ({
    handleTabChange,
    reportSetup,
    tab
}) => (
    <Box data-trackid="chosenReportTabs">
        <MUITabsWrapper
            className="hidePrint"
            value={tab}
            onChange={handleTabChange}
        >
            {reportSetup?.reports.map((report) => (
                <Tab
                    key={`tab_${report.type}`}
                    value={report.type}
                    label={
                        <span
                            style={{
                                alignItems: 'center',
                                display: 'flex',
                                fontSize: FontSizes[3]
                            }}
                        >
                            {report.name}
                        </span>
                    }
                    aria-label={report.name}
                    data-trackid={`reports_chosenReport_${report.type}`}
                />
            ))}
        </MUITabsWrapper>
    </Box>
);
